import React from 'react'
import Navbar from '../inc/Navbar'
import frontshowroomranaghta from "../images/Ranaghat Front Showroom.jpg";

import Ranaghatshowrom from "../images/Ranaghat Shop.jpg";

import Interior from "../images/Interior.jpg";
import Balajisareeranaghat from "../images/Balaji Saree.jpg";



import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import ScrollToTop from "react-scroll-to-top";
import RanaghatShopmap from './RanaghatShopmap';

function Ranaghat() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br />
     
            <br />
            <ScrollToTop smooth top="100" color="maroon" />
     
                         <div className="album py-1">
                <div className="container">
<div className="card mb-3" >
  <div className="row g-0">
    <div className="col-md-4">
      <img src={frontshowroomranaghta} className="img-fluid rounded-start" alt="frontshowroomranaghta"/>
    </div>
    <div className="col-md-8">
      <div className="card-body">
        <div className='color'>
        <h5  className="card-title">Aistala, Ranaghat, Nadia, Pin-741201, WB | India</h5>
        </div>
        <a  className='mb-4' href='tel: +91 9064837572'>9064837572 / <a href='tel: 7501445023'>7501445023</a></a>
      
        <a href='https://g.co/kgs/CUqXFPV' target="_blank" rel="noopener noreferrer">
        <p className="card-text mt-3">Direction Map <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-sign-merge-right" viewBox="0 0 16 16">
  <path d="M8.75 6v1q.211.451.588.95c.537.716 1.259 1.44 2.016 2.196l-.708.708-.015-.016c-.652-.652-1.33-1.33-1.881-2.015V12h-1.5V6H6.034a.25.25 0 0 1-.192-.41l1.966-2.36a.25.25 0 0 1 .384 0l1.966 2.36a.25.25 0 0 1-.192.41z"/>
  <path fill-rule="evenodd" d="M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098zm-1.4.7a.495.495 0 0 1 .7 0l6.516 6.515a.495.495 0 0 1 0 .7L8.35 14.866a.495.495 0 0 1-.7 0L1.134 8.35a.495.495 0 0 1 0-.7L7.65 1.134Z"/>
</svg></p></a>

      </div>
    </div>


                        </div>

                    </div>
                </div>
            </div>



            <div className="album py-1">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                     <div className='hoverimage1'>
                                        <Zoom>
                                            <img src={Ranaghatshowrom} className="card-img-top image2" alt="Ranaghatshowrom"/>
                                        </Zoom>
                                      
                                            <h5 className="overlay1 mb-1"> Showroom Interior Photo</h5>

                                          

                                        

                                    </div>

                                </div>
                                <div className="col-md-6 mt-3">
                                     <div className='hoverimage1'>
                                        <Zoom>
                                            <img src={Interior} className="card-img-top image2" alt="Interior" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="overlay1 mb-1"> Showroom Interior Photo</h5>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6  me-2 mt-3">
                                       <div className='hoverimage1'>
                                        <Zoom>
                                            <img src={Balajisareeranaghat} className="card-img-top image2" alt="Balaji Saree"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="overlay1 mb-1">Showroom Interior Photo</h5>
                                    
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 mt-3">
                                        <div className='hoverimage1'>
                                        <Zoom>
                                            <img src={Balajisareeranaghat} className="card-img-top image2" alt="Balajisaree" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="overlay1 mb-1"> Showroom Interior Photo</h5>
                                           
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>




                    </div>
                </div>
            </div>

            <div className="album py-1">
                <div className="container">
                    <div className="row">





                        <div className="col-md-12 mt-3">

                            <RanaghatShopmap />

                        </div>
                    </div>

                </div>
            </div>


            <br />
            <br />
        </div >
    )
}

export default Ranaghat